import { Typography } from '@weareopenr/component-library';
import styles from '../CreateOptionGroupModal.module.scss';
import { useMemo } from 'react';
import { downStreamExternalSystemIntegrationTypes } from '../../../constants';
import type { IOptionGroupValues } from '../types';
import { UseFormSetValue } from 'react-hook-form/dist/types/form';
import { IAggregator } from '../../../types/aggregator.types';
import { IOptionGroup } from '../../../types/menu.types';
import SelectableListWithControls from 'src/components/SelectableListWithControls';

export const SetPublicationExternalSystems = ({
  selectedExternalSystems,
  setValue,
  externalSystems,
  optionGroup,
}: {
  externalSystems: IAggregator[];
  selectedExternalSystems: string[];
  setValue: UseFormSetValue<IOptionGroupValues>;
  optionGroup?: IOptionGroup;
}) => {
  const checkboxOptions = useMemo(
    () =>
      externalSystems
        .filter((externalSystem) => downStreamExternalSystemIntegrationTypes.includes(externalSystem.integrationType))
        .map((externalSystem) => ({
          id: externalSystem.aggregatorId,
          label: externalSystem.name,
        })),
    [externalSystems],
  );
  return (
    <div className={styles['modal-content']}>
      <Typography size="xxlarge">
        {optionGroup ? 'Edit publishing channels for ' : 'Set Publishing Channels'}
        {optionGroup && <span className={styles['bold-text']}>{optionGroup.name}</span>}
      </Typography>

      <Typography size="medium" weight="regular">
        Apply the publishing channels to the modifier group. The modifier group and all the items within the group will
        not be published to any channel that is not selected.
      </Typography>
      <SelectableListWithControls
        options={checkboxOptions}
        selectedOptionsIds={selectedExternalSystems}
        onOptionChange={(selectedOptions) => setValue('externalSystems', selectedOptions)}
        listDetails={{ title: 'Channels:' }}
      />
    </div>
  );
};
